export type DashboardPeriod = 'gunluk' | 'aylik' | 'yillik';

const OPTIONS: { key: DashboardPeriod; label: string }[] = [
  { key: 'gunluk', label: 'Günlük' },
  { key: 'aylik', label: 'Aylık' },
  { key: 'yillik', label: 'Yıllık' },
];

interface PeriodTabsProps {
  value: DashboardPeriod;
  onChange: (p: DashboardPeriod) => void;
}

export function PeriodTabs({ value, onChange }: PeriodTabsProps) {
  return (
    <div className="inline-flex rounded-lg border border-border bg-surface2 p-0.5" role="tablist" data-testid="period-tabs">
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          type="button"
          role="tab"
          aria-selected={value === o.key}
          onClick={() => onChange(o.key)}
          className={
            'px-4 py-1.5 text-sm font-medium rounded-md transition-colors ' +
            (value === o.key
              ? 'bg-surface text-text shadow-sm'
              : 'text-muted hover:text-text')
          }
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
